import { motion } from "framer-motion";

const chapters = [
  { num: "01", title: "Local drivers, local hearts", text: "Every driver and guide is born-and-raised Puri. They know which lane leads to the best mahaprasad and which beach bend catches the last light." },
  { num: "02", title: "Pricing you can read aloud", text: "₹75/km in town, ₹20/km outstation — car, fuel and driver included; tolls, parking and night halt billed at actuals, receipts shown. No hidden mark-ups." },
  { num: "03", title: "A fleet we'd ride ourselves", text: "Sanitized scooters and bikes, serviced on schedule, delivered to your hotel door with two helmets and a full tank of local tips." },
  { num: "04", title: "Help is never far away", text: "24/7 roadside support across the Puri coastal region. A flat tyre at Chandrabhaga shouldn't cost you a sunset." },
];

export default function Manifesto() {
  return (
    <section id="manifesto" className="py-20 lg:py-32 bg-surface" data-testid="manifesto-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          className="font-mono text-xs uppercase tracking-[0.25em] text-terra mb-14"
        >
          09 · The Random Rider Manifesto
        </motion.p>
        <div className="space-y-0">
          {chapters.map((c, i) => (
            <motion.div
              key={c.num}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.8, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] }}
              className="group grid grid-cols-12 gap-4 py-10 border-t border-ink/15 last:border-b items-start"
              data-testid={`manifesto-chapter-${c.num}`}
            >
              <span className="col-span-3 sm:col-span-2 font-serif text-5xl sm:text-7xl font-black text-ink/10 group-hover:text-terra/40 transition-colors duration-500">
                {c.num}
              </span>
              <div className="col-span-9 sm:col-span-5">
                <h3 className="font-serif text-2xl sm:text-3xl font-bold text-ink leading-tight group-hover:text-terra transition-colors duration-300">
                  {c.title}
                </h3>
              </div>
              <p className="col-span-12 sm:col-span-5 text-sm sm:text-base text-ink/70 leading-relaxed sm:pt-2">
                {c.text}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
